import { useMemo } from 'react'
import { Navigate, useLocation } from 'react-router-dom'

import { useMFAStore } from 'src/shared/store/mfa-store'

interface ShowMFAGuardProps {
  mfaRoute: string
  children: React.ReactNode
}

export default function ShowMFAGuard({ mfaRoute, children }: ShowMFAGuardProps) {
  const { shouldShowMFA, setShouldShowMFA } = useMFAStore()
  const location = useLocation()

  return useMemo(() => {
    // If MFA should be shown, redirect to the MFA setup page and clear the shouldShowMFA flag.
    if (shouldShowMFA) {
      return <Navigate to={mfaRoute + '?redirectTo=' + encodeURIComponent(location.pathname)} replace />
    }
    // Otherwise, render the children.
    return <>{children}</>
  }, [shouldShowMFA, mfaRoute, location.pathname, children, setShouldShowMFA])
}
